const STORAGE_KEY = 'jcalc.device.id';
const HEX32 = /^[0-9a-f]{32}$/;

let inMemoryFallback: string | null = null;

function generate(): string {
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
}

export function getDeviceId(): string {
  try {
    const existing = localStorage.getItem(STORAGE_KEY);
    if (existing && HEX32.test(existing)) return existing;
    const fresh = generate();
    localStorage.setItem(STORAGE_KEY, fresh);
    return fresh;
  } catch {
    // localStorage blocked (private mode etc.). Cache the fallback in module scope so
    // every call within the same JS context returns the same id.
    if (!inMemoryFallback) inMemoryFallback = generate();
    return inMemoryFallback;
  }
}

export function _resetDeviceIdForTest(): void {
  inMemoryFallback = null;
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}
